'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@/lib/utils';
import { useNotificationStore } from '../../model/notification-store';

/**
 * The line, and the only thing on the surface that moves it.
 *
 * Everything above the line landed after the broker last looked. Everything
 * below they have already had on screen. The rule that makes it worth drawing
 * is that OPENING THE BELL DOES NOT MOVE IT: a line that jumps to now the
 * moment you glance at it tells you nothing the second time you glance, which
 * is exactly when a broker between two phone calls needs it. It moves when the
 * broker presses it, and it goes back to the start of the day on Reset.
 *
 * After four days away the line does not turn into a wall of four days. It
 * stays where it was, the days below it stay closed behind their digests, and
 * the only thing above it that is not from today is whatever was carried.
 */
export function ReadMarker(t0) {
  const $ = _c(12);
  const {
    at,
    className
  } = t0;
  const markOpened = useNotificationStore(_temp);
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex items-center gap-2 py-1.5", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="h-px flex-1 bg-linear-to-r from-transparent to-[#5651ff]/35" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== at) {
    t3 = at === null ? "You have not looked today" : `You looked at ${at.toLocaleTimeString("en-AU", {
      hour: "2-digit",
      minute: "2-digit"
    })}`;
    $[3] = at;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== markOpened || $[6] !== t3) {
    t4 = <button type="button" onClick={markOpened} title="Move the line to now, so everything above counts as seen" className="shrink-0 rounded-full bg-white dark:bg-white/12 px-2.5 py-1 text-[10px] font-medium text-[#091E42] dark:text-white shadow-[0_2px_8px_rgba(86,81,255,0.15)] transition-shadow hover:shadow-[0_2px_12px_rgba(86,81,255,0.28)]">{t3}</button>;
    $[5] = markOpened;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="h-px flex-1 bg-linear-to-l from-transparent to-[#5651ff]/35" />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t1 || $[10] !== t4) {
    t6 = <div className={t1}>{t2}{t4}{t5}</div>;
    $[9] = t1;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}
function _temp(s) {
  return s.markOpened;
}